import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  mockBuilderProjects,
  ProjectTypes,
  ProjectLocations,
  CompletionYear,
} from "./mockData/mockBuilderDetails";
import MapView from "@/features/map-view/MapView";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { Button } from "@/components/ui/button";
import ProjectCard from "./ui/project-card";

interface BuilderProfileProps {
  isCompanyDetailHidden: boolean;
}

const BuilderProfile: React.FC<BuilderProfileProps> = ({
  isCompanyDetailHidden,
}) => {
  const mapPins = useSelector(
    (state: RootState) => state.rootReducer.mapViewReducer.mapPins
  );

  const navigate = useNavigate();
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    const loadProfile = () => {
      // Simulate fetching profile data
      console.log("mock builder projects", mockBuilderProjects);
      if (mockBuilderProjects) {
        console.log("data present");
        setHasData(true);
      } else {
        console.log("data not present");
        setHasData(false);
      }
    };

    loadProfile();
  }, [navigate]);

  return hasData ? (
    <div
      className={`w-full flex flex-row border-t ${isCompanyDetailHidden ? "lg:h-[71vh] xl:h-[72vh] 14xl:h-[74vh]" : "lg:h-[47vh] xl:h-[54vh] 14xl:h-[57vh]"}`}
    >
      <div className="lg:w-1/2 xl:w-2/5 14xl:w-1/2 overflow-hidden">
        <MapView
          mapPins={mapPins || []}
          isCompanyDetailHidden={isCompanyDetailHidden}
        />
      </div>
      <div className="lg:w-1/2 xl:w-3/5 14xl:w-1/2 p-0 overflow-y-auto">
        <div className="sticky top-0 z-10 bg-white p-4">
          {/* Filter controls */}
          <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-3 mb-5">
            <Select>
              <SelectTrigger className="bg-white border-[#d1daeb] rounded-lg h-10">
                <SelectValue placeholder="Project Type" />
              </SelectTrigger>
              <SelectContent>
                {ProjectTypes.map((type) => {
                  return (
                    <SelectItem key={type.id} value={type.name.toLowerCase()}>
                      {type.name}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>

            <Select>
              <SelectTrigger className="bg-white border-[#d1daeb] rounded-lg h-10">
                <SelectValue placeholder="Completion Year" />
              </SelectTrigger>
              <SelectContent>
                {CompletionYear.map((year) => {
                  return (
                    <SelectItem key={year.id} value={year.name}>
                      {year.name}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>

            <Select>
              <SelectTrigger className="bg-white border-[#d1daeb] rounded-lg h-10">
                <SelectValue placeholder="Project Location" />
              </SelectTrigger>
              <SelectContent>
                {ProjectLocations.map((location) => {
                  return (
                    <SelectItem
                      key={location.id}
                      value={location.name.toLowerCase()}
                    >
                      {location.name}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </div>
          {/* Section heading and Add button */}
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">
              Builder References & Project History
            </h2>
            <Button
              onClick={() =>
                navigate(`/profile/company-profile/add-new-project`)
              }
              size="lg"
              className="bg-bmpGreen-500 hover:bg-bmpGreen-600 text-white px-5 py-2 rounded-lg text-base font-medium"
            >
              Add New Project
            </Button>
          </div>
        </div>
        {/* Project cards */}
        <div className="grid lg:grid-cols-1 xl:grid-cols-2 gap-3 p-4">
          {mockBuilderProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </div>
  ) : (
    <div className="h-full bg-[#fff] flex items-center justify-center">
      {" "}
      {/* Changed from h-screen to h-full */}
      <div className="text-center max-w-xl px-4">
        <h2 className="text-2xl font-semibold text-green-600 mb-4">
          Showcase Your Completed Projects
        </h2>
        <p className="text-gray-700 text-base leading-relaxed mb-6">
          Add past work with location, builder references, and project details
          to build trust and highlight your experience.
        </p>
        <button
          onClick={() => navigate(`/profile/company-profile/add-new-project`)}
          className="bg-green-600 text-white font-semibold px-6 py-2 rounded-md hover:bg-green-700 transition"
        >
          Add Your First Project
        </button>
      </div>
    </div>
  );
};

export default BuilderProfile;
